import React from 'react';
import { observer } from 'mobx-react';
import { modalStore } from 'apps/modals/app';

import { Overlay, Main, ButtonClose } from './styles';
@observer
export class ModalContainer extends React.Component {
  fadeIn = () => {
    modalStore.FadeIn();
  };

  hideOnOuterClick = e => {
    if (e.target.dataset.modal) {
      if (modalStore.props.hideOnlyOnEsc) {
        return;
      }
      modalStore.Close();
    }
  };

  clickCancel = () => {
    modalStore.Close();
  };

  render() {
    const ModalComponent = modalStore.component;
    if (modalStore.props && modalStore.props.allCustom) {
      return (
        <Overlay
          visible={modalStore.component}
          onTouchStart={this.hideOnOuterClick}
          onMouseDown={this.hideOnOuterClick}
          data-modal={true}
          toFront={modalStore.props && modalStore.props.toFront}
          allCustom
        >
          <ModalComponent
            fadeIn={this.fadeIn}
            clickCancel={this.clickCancel}
            {...modalStore.props}
          />
        </Overlay>
      );
    }
    return (
      <Overlay
        visible={modalStore.component}
        onTouchStart={this.hideOnOuterClick}
        onMouseDown={this.hideOnOuterClick}
        data-modal={true}
        toFront={modalStore.props && modalStore.props.toFront}
      >
        {ModalComponent && (
          <Main
            role='dialog'
            fadedIn={modalStore.fadedIn}
            size={modalStore.props.size}
            small={modalStore.props.small || false}
            noPadding={modalStore.props.noPadding}
            availableRatio={modalStore.props.availableRatio}
          >
            {!(modalStore.large || modalStore.props.noCloseButton) && (
              <ButtonClose
                onClick={this.clickCancel}
                icon='close_small'
                ariaLabel='Close modal'
                variant='minimal'
                size='small'
                outline
              />
            )}
            <ModalComponent
              fadeIn={this.fadeIn}
              clickCancel={this.clickCancel}
              {...modalStore.props}
            />
          </Main>
        )}
      </Overlay>
    );
  }
}
